import React, { useEffect, useState } from 'react';
import '.././App.css';
import { db } from '../firebase';
import { getDoc, doc, query, collection, getDocs, where } from 'firebase/firestore';
import { useParams } from 'react-router-dom';
import moment from 'moment';

export default function Ledgerdetails() {
  const [searchText, setSearchText] = useState("");
  const [mergedItems, setMergedItems] = useState([]);

  const { documentId } = useParams();

  useEffect(() => {
    const fetchItems = async () => {
      try {
        // 1) fetch avakitems for this productid
        const avakQuery = query(collection(db, "avakitems"), where("productid", "==", documentId));
        const avakSnap = await getDocs(avakQuery);
        let avakData = avakSnap.docs.map(s => {
          const d = s.data() || {};
          return {
            id: s.id,
            product: d.product || "",
            quantity: (d.quantity === undefined || d.quantity === null) ? 0 : Number(d.quantity),
            avakid: d.avakid || null,
            raw: d,
            description: "Avak Data"
          };
        });

        // 2) fetch javakitems for this productid
        const javakQuery = query(collection(db, "javakitems"), where("productid", "==", documentId));
        const javakSnap = await getDocs(javakQuery);
        let javakData = javakSnap.docs.map(s => {
          const d = s.data() || {};
          const registerId = d.javakid || d.avakid || null;
          return {
            id: s.id,
            product: d.product || "",
            quantity: (d.quantity === undefined || d.quantity === null) ? 0 : Number(d.quantity),
            registerId,
            raw: d,
            description: "Javak Data"
          };
        });

        // 3) build unique lists of register ids
        const avakRegisterIds = Array.from(new Set(avakData.map(i => i.avakid).filter(Boolean)));
        const javakRegisterIds = Array.from(new Set(javakData.map(i => i.registerId).filter(Boolean)));

        // 4) fetch avakregister dates
        const avakRegMap = {};
        await Promise.all(avakRegisterIds.map(async (id) => {
          try {
            const snap = await getDoc(doc(db, "avakregisters", id));
            avakRegMap[id] = snap.exists() ? (snap.data().avakdate || null) : null;
          } catch (e) {
            avakRegMap[id] = null;
          }
        }));

        // 5) fetch javakregister dates
        const javakRegMap = {};
        await Promise.all(javakRegisterIds.map(async (id) => {
          try {
            const snap = await getDoc(doc(db, "javakregisters", id));
            if (!snap.exists()) {
              javakRegMap[id] = null;
            } else {
              const rd = snap.data();
              javakRegMap[id] = rd.javakdate || rd.avakdate || null;
            }
          } catch (e) {
            javakRegMap[id] = null;
          }
        }));

        // 6) attach dates
        avakData = avakData.map(item => ({
          ...item,
          date: item.avakid ? avakRegMap[item.avakid] || null : null
        }));

        javakData = javakData.map(item => ({
          ...item,
          date: item.registerId ? javakRegMap[item.registerId] || null : null
        }));

        // 7) merge & sort by date (DESC)
        const merged = [...avakData, ...javakData];

        const getTime = (d) => {
          if (!d) return 0;
          const t = new Date(d).getTime();
          return isNaN(t) ? 0 : t;
        };

        // Latest first
        merged.sort((a, b) => getTime(b.date) - getTime(a.date));

        setMergedItems(merged);
      } catch (err) {
        console.error("Error fetching ledger items:", err);
        setMergedItems([]);
      }
    };

    if (documentId) fetchItems();
    else setMergedItems([]);
  }, [documentId]);

  // safe search
  const search = String(searchText || "").toLowerCase();
  const filteredItems = mergedItems.filter(item =>
    String(item.product || "").toLowerCase().includes(search) ||
    String(item.description || "").toLowerCase().includes(search)
  );

  // compute available totals per product
  const stockMap = {};
  mergedItems.forEach(item => {
    const prod = String(item.product || "UNKNOWN");
    const qty = Number(item.quantity || 0);
    if (!stockMap[prod]) stockMap[prod] = { totalAvak: 0, totalJavak: 0 };
    if (item.description === "Avak Data") stockMap[prod].totalAvak += qty;
    else if (item.description === "Javak Data") stockMap[prod].totalJavak += qty;
  });

  return (
    <div>
      <div className="content-wrapper">
        <br />
        <section className="content">
          <div className="container-fluid">
            <button className="btn btn-secondary" style={{ float: "right" }}>
              || Store Ledger Details ||
            </button>
            <br /><br /><br />
            <div className="card card-primary card-outline ex1">
              <div className="p-1">
                <input
                  type="search"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  className='form-control col-sm-4'
                  placeholder='Type here......'
                />
              </div>

              <div className="card-body table-responsive p-0">

                {/* Available Qty per product */}
                <table className="table table-bordered table-hover table-striped table-head-fixed">
                  <tbody>
                    {Object.entries(stockMap).map(([product, vals], idx) => (
                      <tr key={idx}>
                        <td>
                          <b style={{ color: "green" }}>
                            Available {product} - {(vals.totalAvak || 0) - (vals.totalJavak || 0)} Qty
                          </b>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                {/* Ledger Table */}
                <table className="table table-bordered table-hover table-striped table-head-fixed">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Date</th>
                      <th>Description</th>
                      <th>Product</th>
                      <th>Quantity</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredItems.map((item, idx) => (
                      <tr key={idx + 1}>
                        <td>{idx + 1}</td>
                        <td>
                          {item.date && moment(item.date).isValid()
                            ? moment(item.date).format('DD-MM-YYYY')
                            : (item.date ? String(item.date) : '-')}
                        </td>
                        <td>{item.description}</td>
                        <td>{item.product}</td>
                        <td>{item.quantity}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>

              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
